<template>
    <div class="logo-holder-parent md:block md:ml-6">
        <div class="logo-holder">
            <a v-if="homeLink && isExternal(homeLink)" :href="homeLink" class="logo-link">
                <img v-if="teamLogoUrl" class="team-logo" :src="teamLogoUrl" alt="Team Logo" decoding="async" fetchpriority="high"/>
                <img v-else-if="companyLogoUrl" class="team-logo" :src="companyLogoUrl" alt="Company Logo" decoding="async" fetchpriority="high"/>
                <span v-else class="text-logo">Configurator</span>
            </a>
            <Link v-else :href="homeLink ? homeLink : route(props.logoUrl || 'home')" class="logo-link">
                <!-- Prefer global company logo if available -->
                <img v-if="teamLogoUrl" class="team-logo" :src="teamLogoUrl" alt="Team Logo" decoding="async" fetchpriority="high"/>
                <img v-else-if="companyLogoUrl" class="team-logo" :src="companyLogoUrl" alt="Company Logo" decoding="async" fetchpriority="high"/>
                <!-- Else fallback to team logo if available and allowed -->
                <!-- Final fallback: minimal text logo to avoid heavy inline SVG -->
                <span v-else class="text-logo">Configurator</span>
            </Link>
        </div>
    </div>
</template>
<script setup lang="ts">
import {Link, usePage} from "@inertiajs/vue3";
import {computed} from "vue";
import {route} from "ziggy-js";

const props = defineProps({
    useBordexLogo: {
        type: Boolean,
        default: true
    },
    logoUrl: {
        type: String,
        default: null
    }
});

const page = usePage();

const homeLink = computed(() => page.props?.whiteLabel?.homeLink || null);

const isExternal = (url: string) => {
    return url.startsWith('http://') || url.startsWith('https://');
};

// Prefer global company logo independent of team
const appendLogoSize = (url: string | null) => {
    if (!url) {
        return null;
    }

    try {
        const logoUrl = new URL(url, window.location.origin);
        if (logoUrl.origin === window.location.origin && logoUrl.pathname.includes('/shared/')) {
            logoUrl.searchParams.set('w', '160');
        }

        return logoUrl.toString();
    } catch {
        return url;
    }
};

const companyLogoUrl = computed(() => appendLogoSize(page.props?.whiteLabel?.companyLogo || null));

const teamLogoAvailable = computed(() => !!page.props?.whiteLabel?.teamLogo);
const useTeamLogo = computed(() =>  teamLogoAvailable.value);
const teamLogoUrl = computed(() => appendLogoSize(page.props?.whiteLabel?.teamLogo || null));
</script>

<style scoped lang="scss">
.logo-holder-parent {
    flex-shrink: 1;
    max-width: 140px;
    width: auto;
    min-width: 0;
}

.logo-holder {
    max-width: 100%;
    display: flex;
    align-items: center;
}

.team-logo {
    max-height: 50px;
    max-width: 100%;
    height: auto;
    object-fit: contain;

    &-holder {
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 100%;
    }
}

.logo-link {
    display: inline-flex;
    align-items: center;
    min-width: 44px;
    min-height: 44px;
    max-width: 100%;
}

.text-logo {
    display: inline-flex;
    align-items: center;
    height: 50px;
    font-weight: 700;
    color: var(--p-primary-color, #00338d);
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
